import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowRight, Loader2 } from "lucide-react";
import { fmtMoney } from "@/lib/lineMath";

const LABELS = [
  ["rows", "satır değişti"], ["unit_price", "fiyat"], ["quantity", "adet"], ["tax_rate", "KDV"],
  ["discount", "iskonto"], ["currency", "para birimi"], ["added", "yeni satır"], ["deleted", "silinecek"],
];

export default function SaveSummaryDialog({ summary, saving, onConfirm, onCancel }) {
  return (
    <Dialog open={!!summary} onOpenChange={(v) => !v && !saving && onCancel()}>
      <DialogContent className="bg-slate-950 border-slate-800 text-slate-100 max-w-md" data-testid="ws-save-summary">
        <DialogHeader><DialogTitle className="text-base">Kaydetmeden önce özet</DialogTitle></DialogHeader>
        {summary && (
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-1.5">
              {LABELS.filter(([k]) => summary.counts[k]).map(([k, lbl]) => (
                <div key={k} className="flex items-baseline gap-2 border border-slate-800 rounded-sm px-2.5 py-1.5" data-testid={`ws-sum-${k}`}>
                  <span className="font-mono text-lg font-semibold text-slate-50 tabular-nums">{summary.counts[k]}</span>
                  <span className="text-xs text-slate-400">{lbl}</span>
                </div>
              ))}
            </div>
            <div className="border-t border-slate-800 pt-2 space-y-1">
              <div className="text-[10px] uppercase tracking-widest font-mono text-slate-500">Genel Toplam</div>
              {summary.totals.map(({ cur, before, after }) => (
                <div key={cur} className="flex items-center justify-between font-mono text-sm tabular-nums" data-testid={`ws-sum-total-${cur}`}>
                  <span className="text-slate-500">{cur}</span>
                  <span>
                    <span className="text-slate-400">{fmtMoney(before, cur)}</span>
                    <ArrowRight className="inline w-3.5 h-3.5 mx-1.5 text-slate-600" />
                    <span className="text-emerald-300 font-semibold">{fmtMoney(after, cur)}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={saving} className="rounded-sm border-slate-700" data-testid="ws-sum-cancel">Geri Dön</Button>
          <Button onClick={onConfirm} disabled={saving} className="rounded-sm bg-emerald-600 hover:bg-emerald-500" data-testid="ws-sum-confirm">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Onayla ve Kaydet"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
